import CenteredContent from '@picsart/rc/old/CenteredContent';

import useStyles from './styles';

function GridWithTemplatesSkeleton() {
  const styles = useStyles();
  const gridItems = [...Array(12)].map((_, index) => (
    <i className="skeleton" key={`${index}_skeleton`} />
  ));
  return (
    <div className={styles.root}>
      <CenteredContent>
        <div className={styles.skeletonTitle}>
          <i className="skeleton" />
        </div>
        <div className={styles.skeletonGrid}>{gridItems}</div>
      </CenteredContent>
    </div>
  );
}

export default GridWithTemplatesSkeleton;
